/** Inicio del Admin (`/`, T031 · US1): dashboard con contadores y últimas marcaciones. */
import { createFileRoute } from '@tanstack/react-router';

import { SkeletonLines } from '../../components/ui/skeleton';
import { DashboardPage } from '../../features/dashboard/dashboard-page';
import { useMe } from '../../features/shell/use-me';

function Home() {
  const me = useMe();
  if (!me.data) {
    return <SkeletonLines lines={3} />;
  }
  return <DashboardPage me={me.data} />;
}

export const Route = createFileRoute('/_app/')({
  component: Home,
});
